import { render, staticRenderFns } from "./ModalItemEdit.vue?vue&type=template&id=b8042434&scoped=true"
import script from "./ModalItemEdit.vue?vue&type=script&lang=js"
export * from "./ModalItemEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalItemEdit.vue?vue&type=style&index=0&id=b8042434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8042434",
  null
  
)

export default component.exports